import { useDispatch, useSelector } from 'react-redux';
import { navigationActions } from '../../lib/redux/navigation/slice';
import { findParentElementMatchingClass } from '../../utils/shared';

export default function useTriggers() {
  const nav = useSelector((state) => state.navigation?.data);
  const dispatch = useDispatch();

  const _handleUpdateMenuStatus = (menu, status) => {
    dispatch(
      navigationActions.navigationUpdated({
        ...nav,
        menus: { ...nav.menus, [menu]: status },
      })
    );
  };

  const _handleUpdateModalStatus = (modal, status) => {
    dispatch(
      navigationActions.navigationUpdated({
        ...nav,
        modals: { ...nav.modals, [modal]: status },
      })
    );
  };

  const _handleUpdateMultipleModalStatus = (modals) => {
    let modalStatusObj = {};
    modals.forEach((modal) => {
      modalStatusObj = {
        ...modalStatusObj,
        [modal.name]: modal.status,
      };
    });
    dispatch(
      navigationActions.navigationUpdated({
        ...nav,
        modals: { ...nav.modals, ...modalStatusObj },
      })
    );
  };

  const handleSettingMenuBtnClick = () => {
    _handleUpdateMenuStatus('settings', true);
  };

  const handleUserProfileMenuBtnClick = () => {
    _handleUpdateMenuStatus('user', true);
  };

  const handleHelpMenuBtnClick = () => {
    _handleUpdateMenuStatus('help', true);
  };

  const handleSuggestedPromptBtnClick = () => {
    _handleUpdateMenuStatus('suggestedprompt', true);
  };

  const handlePromptGalleryBtnClick = () => {
    _handleUpdateModalStatus('prompt-gallery-modal', true);
  };

  const handleFeaturedMentorClick = () => {
    _handleUpdateModalStatus('featured-mentors-modals', true);
  };

  const handleHelpMenuClick = () => {
    _handleUpdateModalStatus('help-modal', true);
  };

  const handleHelpMenuCloseClick = () => {
    _handleUpdateModalStatus('help-modal', false);
  };

  const handleFaqMenuClick = () => {
    _handleUpdateModalStatus('faq-modal', true);
  };

  const handleFaqMenuCloseClick = () => {
    _handleUpdateModalStatus('faq-modal', false);
  };

  const handleMentorsMenuBtnClick = () => {
    _handleUpdateMenuStatus('settings', false);
    _handleUpdateModalStatus('mentor-list-modal', true);
  };

  const handleLLMProviderMenuBtnClick = () => {
    _handleUpdateMenuStatus('settings', false);
    _handleUpdateModalStatus('llm-modal', true);
  };

  const handleLLMUpdateKeyBtnClick = () => {
    _handleUpdateModalStatus('llm-set-api-key-modal', true);
  };

  const handleCreateMentorBtnClick = () => {
    _handleUpdateModalStatus('mentor-creation-modal', true);
  };

  const handleAddNewPromptBtnClick = () => {
    _handleUpdateModalStatus('add-new-prompt-modal', true);
  };

  const handleOpenEditMentorModal = () => {
    _handleUpdateModalStatus('edit-mentor-modal', true);
  };

  const handleOpenPromptDetailModal = () => {
    _handleUpdateModalStatus('prompt-gallery-element-view-modal', true);
  };

  const handleOpenDatasetResourceTypes = () => {
    _handleUpdateModalStatus('dataset-resource-modal', true);
  };

  const handleUsersMenuBtnClick = () => {
    _handleUpdateModalStatus('users-settings-modal', true);
  };

  const handleManageAccountBtnClick = () => {
    _handleUpdateModalStatus('manage-account-modal', true);
  };

  const handleAIAudioCallBtnClick = () => {
    _handleUpdateModalStatus('ai-audio-chat-modal', true);
  };

  const handleInviteUserBtnClick = () => {
    _handleUpdateModalStatus('users-settings-invite-modal', true);
  };

  const handleShowInvitedUsersBtnClick = () => {
    _handleUpdateModalStatus('users-settings-invited-users-list-modal', true);
  };

  const handleSeeAllMentorsClick = () => {
    _handleUpdateModalStatus('mentor-list-modal', true);
  };

  const handleHeaderMenuToggleClick = () => {
    dispatch(
      navigationActions.navigationUpdated({ ...nav, sidebar: !nav.sidebar })
    );
  };

  const handleOpenFreeTrialModal = () => {
    _handleUpdateModalStatus('not-admin-banner-modal', true);
  };

  const handleMobileHeaderMenuToggleClick = () => {
    dispatch(
      navigationActions.navigationUpdated({
        ...nav,
        mobileSidebar: !nav.mobileSidebar,
      })
    );
  };

  const handleUserTypeSwitchChange = (event) => {
    dispatch(navigationActions.instructorModeUpdated(event.target.checked));
  };

  const handleModalCloseClick = (event) => {
    const parentModal = findParentElementMatchingClass(event.target, 'modal ');
    if (parentModal) {
      const parentModalClassNames = parentModal?.className
        ?.split(' ')
        ?.filter((cls) => cls.trim());
      const specificModalClass = parentModalClassNames[1];
      _handleUpdateModalStatus(specificModalClass, false);
    }
  };

  const handleThemeSwicherBtnClick = () => {
    const bodyEl = document.body;
    if (bodyEl.className.includes('dark-mode')) {
      bodyEl.classList.remove('dark-mode');
      dispatch(navigationActions.darkModeUpdated(false));
    } else {
      bodyEl.classList.add('dark-mode');
      dispatch(navigationActions.darkModeUpdated(true));
    }
  };

  const handleMentorToParentCollapse = () => {
    window.parent.postMessage(
      JSON.stringify({ collapseSidebarCopilot: true }),
      '*'
    );
  };
  return {
    _handleUpdateModalStatus,
    _handleUpdateMultipleModalStatus,
    handleSettingMenuBtnClick,
    handleUserProfileMenuBtnClick,
    handleHelpMenuBtnClick,
    handlePromptGalleryBtnClick,
    handleFeaturedMentorClick,
    handleMentorsMenuBtnClick,
    handleModalCloseClick,
    handleSuggestedPromptBtnClick,
    handleLLMProviderMenuBtnClick,
    handleLLMUpdateKeyBtnClick,
    handleCreateMentorBtnClick,
    handleAddNewPromptBtnClick,
    handleOpenEditMentorModal,
    handleOpenPromptDetailModal,
    handleOpenDatasetResourceTypes,
    handleUserTypeSwitchChange,
    handleUsersMenuBtnClick,
    handleManageAccountBtnClick,
    handleThemeSwicherBtnClick,
    handleAIAudioCallBtnClick,
    handleInviteUserBtnClick,
    handleShowInvitedUsersBtnClick,
    handleHeaderMenuToggleClick,
    handleSeeAllMentorsClick,
    handleMentorToParentCollapse,
    handleHelpMenuClick,
    handleHelpMenuCloseClick,
    handleFaqMenuClick,
    handleFaqMenuCloseClick,
    handleMobileHeaderMenuToggleClick,
    handleOpenFreeTrialModal,
  };
}
